import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "addTagsModal",
  "data-keyboard": "false",
  "data-backdrop": "static",
  tabindex: "-1",
  "aria-labelledby": "addTagsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "iconed-block-list" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "icon-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-tags" })
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", null, "Add Tags for", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_11 = {
  key: 0,
  class: "spinner-border"
}
const _hoisted_12 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_13 = {
  key: 0,
  class: "form-group"
}
const _hoisted_14 = { class: "mid-section pt-0" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "card-head" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
      /*#__PURE__*/_createVNode("h3", { class: "card-title" }, "recently used tags")
    ])
  ])
], -1)
const _hoisted_16 = { class: "activity-block p-0" }
const _hoisted_17 = { class: "inline-list" }
const _hoisted_18 = {
  key: 1,
  class: "disable-button-list"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("h3", { class: "card-title" }, "Disabled Tags", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Button. ")
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h3", { class: "card-title" }, "Add Tag", -1)
const _hoisted_23 = {
  key: 2,
  class: "modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_TagsCard = _resolveComponent("TagsCard")
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("ul", null, [
                _createVNode("li", null, [
                  _hoisted_7,
                  (_ctx.selected)
                    ? (_openBlock(), _createBlock("h5", _hoisted_8, [
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(_ctx.selected.filename), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAddTagsModal && _ctx.closeAddTagsModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_10
            ])
          ]),
          (_ctx.state.ui.isLoading.getTags)
            ? (_openBlock(), _createBlock("div", _hoisted_11))
            : (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.error.errorList.fileTags,
                  hasError: _ctx.state.ui.error.hasError
                }, null, 8, ["errors", "hasError"]),
                (
                _ctx.state.data.recentlyUsedTags &&
                _ctx.state.data.recentlyUsedTags.length
              )
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createVNode("div", _hoisted_16, [
                          _createVNode("div", _hoisted_17, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                          .recentlyUsedTags, (activity, activityIndex) => {
                                return (_openBlock(), _createBlock("li", {
                                  class: "pl-0 pr-1",
                                  key: activityIndex
                                }, [
                                  _createVNode(_component_TagsCard, {
                                    activity: activity,
                                    onSelectedRecentTag: _ctx.selectedTag
                                  }, null, 8, ["activity", "onSelectedRecentTag"])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
                _ctx.state.data.disabledFileTagList &&
                _ctx.state.data.disabledFileTagList.length
              )
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode("ul", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.disabledFileTagList, (tag, tagIndex) => {
                          return (_openBlock(), _createBlock("li", { key: tagIndex }, [
                            _createTextVNode(_toDisplayString(tag.name) + " is disabled.To enable Click ", 1),
                            _createVNode("a", {
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.enableSelectedFileTag(tag))
                            }, _toDisplayString(tag.inProgress ? "Loading..." : "Enable"), 9, ["onClick"]),
                            _hoisted_20
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_Multiselect, {
                    modelValue: _ctx.state.data.tags.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.tags.value = $event)),
                    mode: "tags",
                    searchable: true,
                    createTag: true,
                    options: _ctx.masterTags,
                    onSelect: _ctx.selectTag,
                    onDeselect: _ctx.deSelectTag,
                    onTag: _ctx.addTag
                  }, null, 8, ["modelValue", "options", "onSelect", "onDeselect", "onTag"])
                ])
              ])),
          (!_ctx.state.ui.isLoading.getTags)
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addTagsToFile && _ctx.addTagsToFile(...args)))
                }, " Add tag to File "),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeAddTagsModal && _ctx.closeAddTagsModal(...args)))
                }, " Close ")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}